import { Link } from 'react-router';
import { gameTitle } from '#shared/domain/scoring/index';
import { ScoreDigits, Tag } from '@/ui';
import { copy } from '../copy';
import { useGameDetail } from '../queries';

/**
 * A compact live score for another module's screen (sessions' live hub, a tournament fixture): the
 * title, both scores, a Live tag, and a link to the game. Reads the cached game, so it is cheap.
 */
export function LiveScoreStrip({ gameId }: { gameId: string }) {
  const q = useGameDetail(gameId);
  const g = q.data?.game;
  if (!g) return null;
  return (
    <Link
      to={`/game/${g.id}`}
      className="tts-press flex min-h-14 items-center gap-3 rounded-tts border-3 border-ink bg-white px-3 shadow-btn"
    >
      <span className="flex min-w-0 flex-1 flex-col">
        <span className="tts-display truncate text-sm">{gameTitle(g.mode, g.rules)}</span>
        {g.status === 'live' ? <Tag tone="butter">{copy.game.live}</Tag> : <Tag tone="mint">{copy.game.finalTag}</Tag>}
      </span>
      <ScoreDigits value={g.scoreA} team="a" size="sm" label={copy.newGame.teams.a} />
      <ScoreDigits value={g.scoreB} team="b" size="sm" label={copy.newGame.teams.b} />
    </Link>
  );
}
